import { createActions } from 'redux-actions';

export const {
  // GET ALL ORDERS
  getAllOrdersForDocuments,
  getAllOrdersForDocumentsSuccess,
  getAllOrdersForDocumentsFailure,
  // GET FILTER DOCUMENTS
  getFilterOrdersForDocuments,
  getFilterOrdersForDocumentsSuccess,
  getFilterOrdersForDocumentsFailure,
} = createActions(
  'GET_ALL_ORDERS_FOR_DOCUMENTS',
  'GET_ALL_ORDERS_FOR_DOCUMENTS_SUCCESS',
  'GET_ALL_ORDERS_FOR_DOCUMENTS_FAILURE',
  'GET_FILTER_ORDERS_FOR_DOCUMENTS',
  'GET_FILTER_ORDERS_FOR_DOCUMENTS_SUCCESS',
  'GET_FILTER_ORDERS_FOR_DOCUMENTS_FAILURE'
);
